<template>
  <div class="overlayIsConnected">
    <p class="green" v-if="connectionStatus">{{ $t("socket.online") }}</p>
    <p class="red" v-if="!connectionStatus">{{ $t("socket.offline") }}</p>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
export default {
  data () {
    return {
      socketMessage: ''
    }
  },
  computed: {
    ...mapState({
      connectionStatus: 'isconnected'
    })
  },
  methods: {
    pingServer () {
      // Send the "pingServer" event to the server.
      this.$socket.emit('pingServer', 'PING!')
    }
  }
}
</script>

<style scoped>
p{
    font-size: 15px;
    -moz-text-size-adjust:none;
    -webkit-text-size-adjust: none;
}
.green{
    color: green;
}
.red{
    color: red;
}
.overlayIsConnected{
  opacity: 0.7;
  position: fixed;
  z-index: 10;
  width: 200px;
  right: 0;
  top: 0;
  background-color: black;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/socketTest/socketPing.vue